// src/containers/ListingPageLoader/ListingPageLoader.js

import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Page } from '../../components';
import ListingPage from '../ListingPage/ListingPageCarousel';
import NotFoundPage from '../NotFoundPage/NotFoundPage';
import { createSlug } from '../../util/urlHelpers';

const ListingPageLoader = props => {
  const { slug } = useParams();
  
  const { listingId, listingTitle, lookupInProgress, lookupError } = useSelector(
    state => state.ListingPageLoader
  );

  // Show loading state
  if (lookupInProgress || (!listingId && !lookupError)) {
    return (
      <Page title="Loading..." scrollingDisabled={false}>
        <div style={{ padding: '100px', textAlign: 'center' }}>Loading...</div>
      </Page>
    );
  }

  // Show 404 if not found
  if (lookupError || !listingId) {
    return <NotFoundPage />;
  }

  // Render the actual ListingPage with the resolved UUID
  // The listing data is already loaded in Redux via ListingPage.loadData
  return (
    <ListingPage 
      {...props} 
      params={{ 
        id: listingId.uuid, 
        slug: createSlug(listingTitle) 
      }} 
    />
  );
};

export default ListingPageLoader;